export let apiURL = 'https://myportal.setcpros.com' //'http://localhost:3001'

export function setAPIUrl(hostname) {
  apiURL = `https://${hostname}`
}